import { Action, createFeatureSelector, createReducer, on } from '@ngrx/store';

import { AccountInfo } from '../../models';
import {
  loadProfileImage,
  loadProfileImageFailure,
  loadProfileImageSuccess,
  loadSapUserIdSuccess,
  loginSuccess,
  logout,
} from '../actions/auth.actions';

export interface AuthState {
  accountInfo: AccountInfo;
  sapUserId: string;
  profileImage: {
    url: string;
    loading: boolean;
    errorMessage: string;
  };
}

export const initialState: AuthState = {
  accountInfo: undefined,
  sapUserId: undefined,
  profileImage: {
    url: undefined,
    loading: false,
    errorMessage: undefined,
  },
};

export const authReducer = createReducer(
  initialState,
  on(logout, (): AuthState => initialState),
  on(
    loginSuccess,
    (state, { accountInfo }): AuthState => ({
      ...state,
      accountInfo,
    })
  ),
  on(
    loadProfileImage,
    (state): AuthState => ({
      ...state,
      profileImage: {
        ...state.profileImage,
        loading: true,
      },
    })
  ),
  on(
    loadProfileImageSuccess,
    (state, { url }): AuthState => ({
      ...state,
      profileImage: {
        ...state.profileImage,
        url,
        loading: false,
      },
    })
  ),
  on(
    loadProfileImageFailure,
    (state, { errorMessage }): AuthState => ({
      ...state,
      profileImage: {
        ...state.profileImage,
        errorMessage,
        loading: false,
      },
    })
  ),
  on(
    loadSapUserIdSuccess,
    (state, { sapUserId }): AuthState => ({
      ...state,
      sapUserId,
    })
  )
);

export function reducer(state: AuthState, action: Action): AuthState {
  return authReducer(state, action);
}

export const getAuthState = createFeatureSelector<AuthState>('azure-auth');
